const mapping: Record<string, string> = {
  id: 'e=>e.Id',
}

export const mapSortEngineMediaPackParam = (key: string) => mapping[key]
